<template>
  <div class="share-url-container">
    <button class="share-add-link-button" aria-label="Share"
    @click="showPopup = !showPopup" v-if="buttonText">
      {{buttonText}}
    </button>
    <button class="share-button-icon" aria-label="Share"
      @click="showPopup = !showPopup" v-else>
      <font-awesome-icon :icon="['fa', 'share-alt']" size="lg">
      </font-awesome-icon>
    </button>
    <div class="backdrop" v-if="showPopup">
      <div class="popup" v-on-clickaway="hidePopup">
        <font-awesome-icon :icon="['fas', 'times']" size="1x" class="x-button"
          @click="hidePopup()">
        </font-awesome-icon>
        <div class="title">
          Share
        </div>
        <social-sharing :url="fullUrl"
          inline-template
          @open="open"
          :quote="title"
          :title="title"
          :description="description"
          hastags="youpaired"
          twitter-user="youpaired">
          <div class="networks">
            <network network="email" class="email-icon">
              <font-awesome-icon :icon="['fa', 'envelope']" size="2x"/>
            </network>
            <network network="facebook" class="facebook-icon">
              <font-awesome-icon :icon="['fab', 'facebook-square']" size="2x"/>
            </network>
            <!-- <network network="facebook">
              <font-awesome-icon :icon="['fab', 'facebook-messenger']" size="2x"/>
            </network> -->
            <network network="twitter" class="twitter-icon">
              <font-awesome-icon :icon="['fab', 'twitter-square']" size="2x"/>
            </network>
            <network network="linkedin" class="linkedin-icon">
              <font-awesome-icon :icon="['fab', 'linkedin']" size="2x"/>
            </network>
          </div>
        </social-sharing>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'ShareUrl',
  mixins: [clickaway],
  props: {
    url: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      defaut: '',
    },
    title: {
      type: String,
      defaut: '',
    },
    description: {
      type: String,
      defaut: '',
    },
  },
  computed: {
    fullUrl() {
      return `${process.env.VUE_APP_URL}${this.url}`;
    },
  },
  data() {
    return {
      showPopup: false,
    };
  },
  methods: {
    hidePopup() {
      this.showPopup = false;
    },
    // FYI this does not handle the local mail client opening up
    open(network) {
      this.$ga.event('event', 'openSharePopup', network, 1);
    },
  },
};

</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

.share-url-container {
  position: relative;
}

.share-button-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08);
  background: white;
  border-radius: 50%;
  height: 2rem;
  width: 2rem;
  color: white;
  text-decoration: none;
  cursor: pointer;
  & svg {
    color: black;
  }
}

.backdrop {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 0.3s;
  z-index: 100;
}

.popup {
  position: absolute;
  text-align: center;
  max-width: 25rem;
  padding: 2rem;
  width: 80%;
  max-height: 75%;
  overflow: scroll;
  background-color: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  border-radius: 0.375rem;
  -webkit-font-smoothing: antialiased;
}

.x-button {
  position: absolute;
  top: 0.625rem;
  right: 0.25rem;
  margin: 1rem;
  cursor: pointer;
  &:hover {
    filter: brightness(0.6);
  }
}

.title {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

</style>

<style lang="scss">
@import '@/assets/youpaired-colors.scss';

.networks svg {
  cursor: pointer;
  padding: 0.5rem;
  &:hover {
    filter: brightness(80%);
  }
}

.email-icon {
  color: #a0a0a0;
}
.facebook-icon {
  color: $facebook;
}

.twitter-icon {
  color: $twitter;
}

.linkedin-icon {
  color: $linkedin;
}

.share-add-link-button {
    line-height: 0.8;
    justify-content: center;
    border-width: 1px;
    border-style: solid;
    border-radius: 3px;
    color: #444444;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
     background-color: #fff;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    padding: 11px 24px;
    box-shadow: 0 1px 1px 0 rgba(0,0,0,.05);
}
</style>
